module.exports = __webpack_public_path__ + "static/media/insect(6).d053c104.PNG";